import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import opciones from "./modules/opciones-module";
import ciudades from "./modules/ciudades-module";
import terminales from "./modules/terminales-module";
import dispositivos from "./modules/dispositivos-module";
import agencias from "./modules/agencias-module";
import layouts from "./modules/layouts-module";
import unidades from "./modules/unidades-module";
import operadores from "./modules/operadores-module";
import tramos from "./modules/tramos-module";
import rutas from "./modules/rutas-module";
import precios from "./modules/precios-module";
import descuentos from "./modules/descuentos-module";
import corridas from "./modules/corridas-module";
import subcorridas from "./modules/subcorridas-module";
import ventas from "./modules/ventas-module";
import boletos from "./modules/boletos-module";
import movimientos from "./modules/movimientos-module";
import arqueos from "./modules/arqueos-module";
import equipajes from "./modules/document-module";
import boarding from "./modules/boarding-module";
import facturas from "./modules/facturas-module";
import autorizaciones from "./modules/autorizaciones-module";
import reporte_boletos from "./modules/reporte-boletos-module";
import reporte_salidas from "./modules/reporte-salidas-module";

// import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import roles from "./modules/roles-module";
import reset from "./modules/reset";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    opciones,
    ciudades,
    terminales,
    dispositivos,
    agencias,
    layouts,
    unidades,
    operadores,
    tramos,
    rutas,
    precios,
    descuentos,
    corridas,
    subcorridas,
    ventas,
    boletos,
    movimientos,
    arqueos,
    // alerts,
    profile,
    users,
    roles,
    reset,
    equipajes,
    boarding,
    facturas,
    autorizaciones,
    reporte_boletos,
    reporte_salidas
  }
});
